import { render, staticRenderFns } from "./Verdict.vue?vue&type=template&id=90525f12&scoped=true&"
import script from "./Verdict.vue?vue&type=script&lang=js&"
export * from "./Verdict.vue?vue&type=script&lang=js&"
import style0 from "./Verdict.vue?vue&type=style&index=0&id=90525f12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90525f12",
  null
  
)

export default component.exports